import React from 'react'
import { IonModal, IonList } from '@ionic/react'
import './BottomSheetModal.component.css'

export interface IBottomSheetProps {
  id: string
  dataTestId?: string
  isOpen: boolean
  onClose: () => void
  headerContent?: React.ReactNode | string
  footerContent?: React.ReactNode
  content: React.ReactNode
  modalClasses?: string
}

const BottomSheetModalComponent: React.FC<IBottomSheetProps> = ({
  id = 'BottomSheetModal',
  dataTestId = 'BottomSheetModal',
  isOpen,
  onClose,
  headerContent,
  footerContent,
  content,
  modalClasses = '',
}) => {
  return (
    <IonModal
      id={id}
      data-testid={dataTestId}
      isOpen={isOpen}
      onDidDismiss={onClose}
      className={`${modalClasses} bottom-sheet-modal`}>
      {headerContent}
      <IonList id='BottomSheetContent' className='bottom-sheet-content'>
        {content}
      </IonList>
      {footerContent}
    </IonModal>
  )
}

export default BottomSheetModalComponent
